import axios from 'axios';
import API_URL from '../api/baseURL'; // If you’re in src/pages or src/components

// Fetch confirmed quotations for a vehicle
export const fetchConfirmedQuotations = async (vehicleId, token) => {
  const res = await axios.get(`${API_URL}/workshop-quotations/confirmed/${vehicleId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

// Fetch quotation summary (pending + revised)
export const fetchQuotationSummary = async (token) => {
  const res = await axios.get(`${API_URL}/workshop-quotations/summary`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data; // { pendingQuotations: number, revisedQuotations: number }
};

// Fetch invoice summary (unpaid + pending quotation count if needed)
export const fetchInvoiceSummary = async (token) => {
  const res = await axios.get(`${API_URL}/workshop-invoices/summary`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data; // { pendingQuotations: number, unpaidInvoices: number }
};
